export function exportParamsFromHash(hash) {
  return hash
    ?.split('&')
    .map(v => v.split('='))
    .reduce((pre, [key, value]) => ({ ...pre, [key.replace('#', '')]: value }), {});
}
